@if (vm$ | async; as vm) {
  <div class="uw-dialog-header">
    <h1 class="uw-dialog-heading">{{ "profile.update_alert" | translate }}</h1>
    <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
  <div class="uw-dialog-content">
    <div [formGroup]="vm.form" class="alert-detail__form">
      <div class="uw-field">
        <label class="uw-label">
          {{ "common.description"  | translate }}
        </label>
        <p>{{ vm.form.value.description }}</p>
      </div>
      <div class="uw-field">
        <label for="content" class="uw-label">
          {{ "profile.english_content" | translate }}
        </label>
        <textarea id="content" type="text" formControlName="content" class="uw-textarea"></textarea>
        @if (vm.form.get('content')?.errors) {
          <span class="uw-error-message">{{ "errors.required" | translate }}</span>
        }
      </div>
      <div class="uw-field">
        <label for="contentFr" class="uw-label">
          {{ "profile.french_content"  | translate }}
        </label>
        <textarea id="contentFr" type="text" formControlName="contentFr" class="uw-textarea"></textarea>
        @if (vm.form.get('contentFr')?.errors) {
          <span class="uw-error-message">{{ "errors.required" | translate }}</span>
        }
      </div>
    </div>
  </div>
  <div class="uw-dialog-footer">
    <div class="uw-actions">
      <button class="uw-stroked-button" mat-dialog-close>
        {{ "common.cancel" | translate }}
      </button>
      <button class="uw-default-button" (click)="save(vm.form.value)" [disabled]="vm.form.pristine || !vm.form.valid">
        {{ "common.save" | translate }}
      </button>
    </div>
  </div>
}